module.exports = __webpack_public_path__ + "static/home_progress@3x-e6be9ece5a871e1eb1bc78f37a2da4c2.png";